<template>
  <main>
    <CryptoUnsupportedNotice
        v-if="isConfirmationVisible"
        @addCryptoConfirmed="handleAddConfirmed(tickerSymbol, apxSecurityId, apxSecuritySymbol, quotedAs, xigniteId)"
        @addCryptoCancelled="handleAddCancelled"
    />
    <article class="row left-align">
      <section class="col s12">
        <router-link to="/tickeradmin/listcompanies" class="blue-grey-text text-darken-4 strong">Security Master</router-link>
        >
        <span>Add Crypto</span>
      </section>
    </article>
    <h4>Add Crypto</h4>
    <article class="row container">
      <section class="input-field col s12">
        <input type="text"
               placeholder="BTC"
               v-model="tickerSymbol"
        >
        <label class="active">Symbol</label>
      </section>
    </article>
    <article class="row container grey lighten-4" v-show="$auth.hasRoles('admin')">
      <section class="input-field col s6">
        <input type="number"
               placeholder="Some APX Security ID"
               v-model="apxSecurityId"
        >
        <label class="active">APX Security ID</label>
      </section>
      <section class="input-field col s6">
        <input type="text"
               placeholder="Some APX Security Symbol"
               v-model="apxSecuritySymbol"
        >
        <label class="active">APX Security Symbol</label>
      </section>
    </article>
    <article class="row container">
      <section class="input-field col s6">
        <input type="text"
               class="validate"
               v-model="xigniteId"
        >
        <label class="active">
          Xignite ID
        </label>
      </section>
      <section class="input-field col s6">
        <select class="browser-default"
                v-model="quotedAs"
        >
          <option value="USD">USD</option>
          <option value="AUD">AUD</option>
          <option value="CAD">CAD</option>
          <option value="EUR">EUR</option>
          <option value="GBP">GBP</option>
        </select>
        <label class="active">Quoted As</label>
      </section>
    </article>
    <article class="row container">
      <section class="input-field col s6">
        <CryptoSearch
          @picked = 'handleCryptoSearchPick'
          :supported-cryptos="supportedCryptos"
        />
        <label class="active">Search for Xignite ID</label>
      </section>
      <section class="col s6">
        <p class="left" style="text-align: left">
          To find the Xignite ID, search for the provider symbol by typing in the
          <strong>name</strong> of the crypto in the "Search for Xignite ID" field.
        </p>
        <p class="left" style="text-align: left">For example, for Popsicle Finance (ICE), search
          by typing "Pop" in the search field. Then click on the correct crypto to populate the "Xignite ID"
          field.
        </p>
      </section>
    </article>
    <article class="row container">
      <section class="col s12">
        <input class="btn waves-effect waves-light teal accent-4 right"
               type="button"
               value="Submit"
               :disabled="isSubmitting"
               @click="verifyCrypto(tickerSymbol, apxSecurityId, apxSecuritySymbol, quotedAs, xigniteId)"
        >
      </section>
    </article>
  </main>
</template>

<script>
import axios from 'axios';
import CryptoSearch from '@/components/CryptoSearch.vue';
import CryptoUnsupportedNotice from '@/components/CryptoUnsupportedNotice.vue';

export default {
  name: 'TickerAdminAddCrypto',
  components: { CryptoSearch, CryptoUnsupportedNotice },
  props: {},
  methods: {
    async handleAddConfirmed(tickerSymbol, apxSecurityId, apxSecuritySymbol, quotedAs) {
      this.isConfirmationVisible = false;
      await this.addCrypto(tickerSymbol, apxSecurityId, apxSecuritySymbol, quotedAs);
    },
    handleAddCancelled() {
      this.isSubmitting = false;
      this.isConfirmationVisible = false;
    },
    async fetchCryptos() {
      let xigniteCryptoListUrl = `${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/cryptos/xignite/`;
      const { data } = await axios
        .get(xigniteCryptoListUrl)
        .then(response => {
          this.supportedCryptos = response.data.Cryptos.filter(crypto => crypto);
        })
        .catch(error => {
          console.log(error);
        });
    },
    async verifyCrypto(tickerSymbol, apxSecurityId, apxSecuritySymbol, quotedAs, xigniteId) {
      this.isSubmitting = true;
      if (!this.validateForm(tickerSymbol, apxSecurityId, apxSecuritySymbol, quotedAs, xigniteId)) {
        this.isSubmitting = false;
        return;
      }

      const foundCrypto = this.supportedCryptos.find(crypto => crypto.Symbol.toLowerCase() === xigniteId.toLowerCase());

      // If Xignite doesn't support the crypto, display unsupported notice and exit function.
      if (!foundCrypto) {
        this.isConfirmationVisible = true;
        return;
      }

      // Otherwise, if it is supported, add it.
      await this.addCrypto(tickerSymbol, apxSecurityId, apxSecuritySymbol, quotedAs, xigniteId);
    },
    async addCrypto(tickerSymbol, apxSecurityId, apxSecuritySymbol, quotedAs, xigniteId) {
      this.isSubmitting = true;
      await axios.post(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/add_crypto/`, {
        analyst_id: this.$auth.user.pk,
        symbol: tickerSymbol.toUpperCase(),
        apx_security_id: parseInt(apxSecurityId),
        apx_symbol: apxSecuritySymbol,
        quoted_as: quotedAs,
        xignite_id: xigniteId ? xigniteId.toUpperCase() : null,
      }).then(() => {
        this.toast(`Successfully added "CRYPTO:${tickerSymbol.toUpperCase()}".`, 'green');
      }).catch((error) => {
        if (error.response.status === 409) {
          this.toast(`"CRYPTO:${tickerSymbol.toUpperCase()}" already exists.`, 'pink');
        } else {
          this.toast('There was an error when adding the crypto. Contact #investing-tech-help for assistance.', 'pink');
        }
      });
      this.isSubmitting = false;
    },
    validateForm() {
      if (![this.tickerSymbol].every(arg => Boolean(arg))) {
        this.toast('Please populate the "Symbol field', 'pink');
        return false;
      }
      return true;
    },
    handleCryptoSearchPick(data) {
      this.xigniteId = data;
    },
  },
  data() {
    return {
      company: '',
      tickerSymbol: '',
      apxSecurityId: null,
      apxSecuritySymbol: '',
      quotedAs: 'USD',
      environment: 'production',
      xigniteId: '',
      supportedCryptos: [],
      isConfirmationVisible: false,
      isSubmitting: false,
    };
  },
  mounted() {
    this.fetchCryptos();
    this.environment = window.env.ENVIRONMENT;
  },
  watch: {
    xigniteId(newVal, oldVal) {
      this.apxSecuritySymbol = `${newVal}-crypto`.toLowerCase();
      if (this.quotedAs !== 'USD') {
        this.apxSecuritySymbol = `${this.xigniteId.toLowerCase()}-crypto-${this.quotedAs.toLowerCase()}`;
      } else {
        this.apxSecuritySymbol = `${this.xigniteId.toLowerCase()}-crypto`;
      }
      if (newVal === '') {
        this.apxSecuritySymbol = '';
      }
    },
    quotedAs(newVal, oldVal) {
      if (this.xigniteId === '') {
        this.apxSecuritySymbol = '';
        return;
      }
      if (this.quotedAs !== 'USD') {
        this.apxSecuritySymbol = `${this.xigniteId.toLowerCase()}-crypto-${this.quotedAs.toLowerCase()}`;
      } else {
        this.apxSecuritySymbol = `${this.xigniteId.toLowerCase()}-crypto`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';


</style>
